import { AbstractWriteValueCommand } from "./AbstractWriteValueCommand";

export class WriteValueCommand<TSource, TValue> extends AbstractWriteValueCommand<TSource, TValue> {
  constructor(private readonly _read: (s: TSource) => TValue, private readonly _write: (s: TSource, v: TValue) => void, value: TValue) {
    super(value);
  }

  protected read(source: TSource): TValue {
    return this._read(source);
  }

  protected write(source: TSource, value: TValue): void {
    this._write(source, value);
  }
}
